module.exports = __webpack_public_path__ + "static/media/7.19.082740b8.png";